/*
 * 下载中心固定手指提示、二维码几何同步与渠道二维码弹层交互。
 * 手指是固定在目标附近的视觉指引，不参与点击，也不替换鼠标光标。
 */
export default function installDownloadCenterGuide () {
  if (typeof document === 'undefined') return function () {}

  var cleanups = []
  var on = function (target, type, handler, options) {
    if (!target) return
    target.addEventListener(type, handler, options)
    cleanups.push(function () { target.removeEventListener(type, handler, options) })
  }

  var launch = document.querySelector('#channel-qr-launch')
  var popover = document.querySelector('#channel-qr-popover')
  var stageLaunch = document.querySelector('#qr-launch-button')
  var channelConsole = document.querySelector('.channel-console')
  var fingerPortals = []
  var layoutFrame = 0
  var layoutTimers = []
  var layoutResizeObserver = null
  var layoutMutationObserver = null
  var androidQrSize = 0
  var androidQrShift = 0

  var prepareQrButton = function (button, guideClass) {
    if (!button) return
    var legacyHint = button.nextElementSibling
    if (legacyHint && legacyHint.classList.contains('qr-click-hint')) legacyHint.remove()
    button.classList.add('qr-guide-button', guideClass)
    var label = button.querySelector(':scope > .qr-guide-label')
    if (label) label.remove()
  }

  prepareQrButton(launch, 'channel-qr-guide')
  prepareQrButton(stageLaunch, 'stage-qr-guide')

  var appendFinger = function (resolveAnchor, className, delay, locate) {
    var cue = document.createElement('span')
    cue.className = 'tap-finger-cue ' + className
    cue.setAttribute('aria-hidden', 'true')
    cue.style.setProperty('--tap-delay', delay + 's')
    cue.innerHTML = '<i class="tap-finger-ripple"></i><b class="tap-finger-glyph"><img src="/hand-pointer-cursor.svg" alt="" draggable="false"></b>'
    document.body.appendChild(cue)
    fingerPortals.push({ resolveAnchor: resolveAnchor, cue: cue, locate: locate })
  }

  appendFinger(
    function () { return document.querySelector('#featured-mark') || document.querySelector('#featured') },
    'download-click-cue featured-tap-finger',
    .35,
    function (rect) { return { x: rect.right - 42, y: rect.bottom - 18 } }
  )
  appendFinger(
    function () { return document.querySelector('.system[data-system="android"]') },
    'menu-tap-finger',
    0,
    function (rect) { return { x: rect.right - 62, y: rect.top + rect.height / 2 - 20 } }
  )
  appendFinger(
    function () { return document.querySelector('#channel-qr-launch') },
    'channel-qr-tap-finger',
    .65,
    function (rect) { return { x: rect.right - 15, y: rect.bottom - 8 } }
  )
  appendFinger(
    function () { return document.querySelector('#qr-launch-button') },
    'stage-qr-tap-finger',
    1.3,
    function (rect) { return { x: rect.right - 15, y: rect.bottom - 8 } }
  )
  appendFinger(
    function () { return document.querySelector('.download-bean-trigger') },
    'universe-bean-tap-finger',
    1.85,
    function (rect) {
      return {
        x: rect.left + rect.width * .70 - 15,
        y: rect.top + rect.height * .67 - 8
      }
    }
  )

  var positionFingerPortals = function () {
    fingerPortals.forEach(function (portal) {
      var anchor = portal.resolveAnchor()
      if (!anchor || !anchor.isConnected) {
        portal.cue.style.setProperty('--tap-left', '-100px')
        portal.cue.style.setProperty('--tap-top', '-100px')
        return
      }
      var rect = anchor.getBoundingClientRect()
      var point = portal.locate(rect)
      portal.cue.style.setProperty('--tap-left', point.x.toFixed(2) + 'px')
      portal.cue.style.setProperty('--tap-top', point.y.toFixed(2) + 'px')
    })
  }

  var syncQrFlowGeometry = function () {
    var cards = Array.prototype.slice.call(document.querySelectorAll(
      '.channel-console:not(.stores-only) .channel-grid .channel-card'
    ))
    var visibleCards = cards.filter(function (card) {
      var rect = card.getBoundingClientRect()
      return rect.width > 0 && rect.height > 0
    })
    var referenceCard = visibleCards[visibleCards.length - 1]
    if (!referenceCard) return

    var cardHeight = Number.parseFloat(window.getComputedStyle(referenceCard).height)
    if (!Number.isFinite(cardHeight) || cardHeight <= 0) return

    var activeSystemNode = document.querySelector('.system.active')
    var activeSystem = activeSystemNode ? activeSystemNode.dataset.system : 'android'
    var measuredQrSize = cardHeight * 1.05 * 1.2
    var measuredQrShift = (measuredQrSize - cardHeight) / 2

    if (activeSystem === 'android' || !androidQrSize) {
      androidQrSize = measuredQrSize
      androidQrShift = measuredQrShift
    }
    var reuseAndroidSize = ['windows', 'macos', 'linux', 'web'].indexOf(activeSystem) >= 0
    var qrSize = reuseAndroidSize ? androidQrSize : measuredQrSize
    var qrShift = reuseAndroidSize ? androidQrShift : measuredQrShift
    document.documentElement.style.setProperty('--channel-card-flow-height', cardHeight + 'px')
    document.documentElement.style.setProperty('--channel-qr-flow-size', qrSize + 'px')
    document.documentElement.style.setProperty('--channel-qr-flow-shift', qrShift + 'px')

    var consoleElement = referenceCard.closest('.channel-console')
    if (!consoleElement) return
    var cardRect = referenceCard.getBoundingClientRect()
    var consoleRect = consoleElement.getBoundingClientRect()
    var scaleY = consoleElement.offsetHeight > 0 ? consoleRect.height / consoleElement.offsetHeight : 1
    var borderTop = Number.parseFloat(window.getComputedStyle(consoleElement).borderTopWidth) || 0
    var cardTop = ((cardRect.top - consoleRect.top) / (scaleY || 1)) - borderTop
    document.documentElement.style.setProperty('--channel-card-flow-top', (cardTop - qrShift) + 'px')
  }

  var syncPopoverAnchor = function () {
    if (!launch || !popover) return
    var container = popover.offsetParent
    if (!container) return
    var containerRect = container.getBoundingClientRect()
    var launchRect = launch.getBoundingClientRect()
    var scaleX = container.offsetWidth ? containerRect.width / container.offsetWidth : 1
    var scaleY = container.offsetHeight ? containerRect.height / container.offsetHeight : 1
    var right = (containerRect.right - launchRect.right) / (scaleX || 1)
    var bottom = (containerRect.bottom - launchRect.bottom) / (scaleY || 1)
    popover.style.setProperty('--channel-qr-anchor-right', right + 'px')
    popover.style.setProperty('--channel-qr-anchor-bottom', bottom + 'px')
  }

  var refreshLayout = function () {
    layoutFrame = 0
    syncQrFlowGeometry()
    positionFingerPortals()
    if (popover && popover.classList.contains('open')) syncPopoverAnchor()
  }

  var scheduleLayout = function () {
    cancelAnimationFrame(layoutFrame)
    layoutFrame = requestAnimationFrame(refreshLayout)
  }

  var setOpen = function (open) {
    if (!launch || !popover) return
    if (open) syncPopoverAnchor()
    popover.classList.toggle('open', open)
    popover.setAttribute('aria-hidden', String(!open))
    launch.setAttribute('aria-expanded', String(open))
  }

  var desktopHover = window.matchMedia('(hover: hover) and (pointer: fine)')
  var hoverCloseTimer = 0
  var cancelHoverClose = function () {
    clearTimeout(hoverCloseTimer)
    hoverCloseTimer = 0
  }
  var scheduleHoverClose = function () {
    if (!desktopHover.matches) return
    cancelHoverClose()
    hoverCloseTimer = window.setTimeout(function () { setOpen(false) }, 120)
  }

  if (launch && popover) {
    on(launch, 'mouseenter', function () {
      if (!desktopHover.matches) return
      cancelHoverClose()
      setOpen(true)
    })
    on(launch, 'mouseleave', scheduleHoverClose)
    on(popover, 'mouseenter', cancelHoverClose)
    on(popover, 'mouseleave', scheduleHoverClose)
    on(launch, 'click', function (event) {
      event.stopPropagation()
      if (desktopHover.matches) {
        cancelHoverClose()
        setOpen(true)
        return
      }
      setOpen(!popover.classList.contains('open'))
    })
    on(popover, 'click', function (event) { event.stopPropagation() })
    on(document, 'click', function () {
      setOpen(false)
      scheduleLayout()
    })
    on(document, 'keydown', function (event) {
      if (event.key === 'Escape') setOpen(false)
    })
    if (desktopHover.addEventListener) {
      on(desktopHover, 'change', function () { setOpen(false) })
    } else if (desktopHover.addListener) {
      var handleHoverChange = function () { setOpen(false) }
      desktopHover.addListener(handleHoverChange)
      cleanups.push(function () { desktopHover.removeListener(handleHoverChange) })
    }
    document.querySelectorAll('.system, .emulator-button, .product-entry-button, .official-site-button').forEach(function (control) {
      on(control, 'click', function () {
        setOpen(false)
        scheduleLayout()
      })
    })
  }

  on(window, 'resize', scheduleLayout, { passive: true })
  on(window, 'scroll', scheduleLayout, { passive: true, capture: true })

  if ('ResizeObserver' in window) {
    layoutResizeObserver = new window.ResizeObserver(scheduleLayout)
    if (channelConsole) layoutResizeObserver.observe(channelConsole)
    fingerPortals.forEach(function (portal) {
      var anchor = portal.resolveAnchor()
      if (anchor) layoutResizeObserver.observe(anchor)
    })
  }
  if ('MutationObserver' in window && channelConsole) {
    layoutMutationObserver = new window.MutationObserver(scheduleLayout)
    layoutMutationObserver.observe(channelConsole, {
      childList: true,
      subtree: true
    })
  }

  scheduleLayout()
  layoutTimers.push(window.setTimeout(scheduleLayout, 250))
  layoutTimers.push(window.setTimeout(scheduleLayout, 800))

  return function stop () {
    clearTimeout(hoverCloseTimer)
    cancelAnimationFrame(layoutFrame)
    layoutTimers.forEach(function (timer) { clearTimeout(timer) })
    if (layoutResizeObserver) layoutResizeObserver.disconnect()
    if (layoutMutationObserver) layoutMutationObserver.disconnect()
    cleanups.forEach(function (off) { off() })
    cleanups = []
    fingerPortals.forEach(function (portal) { portal.cue.remove() })
    fingerPortals = []
    document.documentElement.style.removeProperty('--channel-card-flow-height')
    document.documentElement.style.removeProperty('--channel-qr-flow-size')
    document.documentElement.style.removeProperty('--channel-qr-flow-shift')
    document.documentElement.style.removeProperty('--channel-card-flow-top')
  }
}



// WEBPACK FOOTER //
// ./src/download/download-center-guide.js